import React from 'react';
import { createRoot } from 'react-dom/client';

export default async (el) => {
  const name = el.dataset.template;

  if (name) {
    try {
      const { default: Template } = await import(`../templates/${name}`);

      const config = JSON.parse(
        el.getElementsByTagName('script')?.[0]?.innerHTML || '{}',
      );

      const root = createRoot(el);
      root.render(<Template name={name} config={config} />);
    } catch (err) {
      console.warn(err);
    }
  }
};
